import * as React from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';

import { ticketContactIdSelector } from '@/redux/app/selectors/ticket';
import { NewNoteForm } from '../../../note';

import { ContactMuteButton } from './ContactMuteButton';
import { ContactOptInOutButton } from './ContactOptInOutButton';
import { NotesList } from './NotesList';
import { EmailTranscriptButton } from './EmailTranscriptButton';
import { ShowDataEventsButton } from './ShowDataEventsButton';

export interface NotesPanelContentProps {
  ticket: string;
  open: boolean;
  handlePressClose: () => void;
  handleEmailTranscriptClick: () => void;
  handleDataEventsClick: () => void;
  showDataEvents: boolean;
}

export const NotesPanelContent = ({
  ticket, open, handlePressClose, handleEmailTranscriptClick, handleDataEventsClick, showDataEvents,
}: NotesPanelContentProps) => {
  const contactId = useSelector(_.partial(ticketContactIdSelector, ticket));

  return (
    <div className="ui-panel-inner">
      <div className="contact-tags">
        <div className="heading ">
          <div className="spacer" />
          <div className="button-bin">
            <EmailTranscriptButton handleClick={handleEmailTranscriptClick} />
            <ShowDataEventsButton
              handleClick={handleDataEventsClick}
              showDataEvents={showDataEvents}
            />
            <br />
            <ContactMuteButton contactId={contactId} />
            <ContactOptInOutButton contactId={contactId} />
          </div>
          <button type="button" className="notes-button close noselect" onClick={handlePressClose}>&#xf2d7;</button>
        </div>
      </div>
      <div className="heading">
        <h3>Notes</h3>
        {/* <%= link_to '', toggle_show_avo_notes_user_path(current_user.hash_id), remote: true, onclick: "$(this).toggleClass('visible');", method: :PATCH, id: 'toggle-notes', class: current_user.show_avo_notes? ? 'visible' : '', alt: "View notes in Conversation", title: "View notes in Conversation" %> */}
      </div>

      <div className="pusher" />
      {open && <NotesList ticket={ticket} />}
      <NewNoteForm ticket={ticket} />
    </div>
  );
};
